import { useCallback, useMemo } from "react";

import { organizationEndpoints } from "@api/Endpoints";
import { fetcherHead } from "@utils/swr-utils";

export function useGetUniqueCheck() {
  const uniqueCheck = useCallback(
    async (organizationName: string, organizationIdToExclude?: string) => {
      if (!organizationName) return;

      const url = organizationEndpoints.uniqueCheck(
        organizationName,
        organizationIdToExclude
      );
      const result = await fetcherHead(url);

      return result;
    },
    []
  );

  return useMemo(() => ({ uniqueCheck }), [uniqueCheck]);
}
